import React, { useEffect, useState } from 'react';
import { Switch, Tooltip } from 'antd';
import { BulbOutlined } from '@ant-design/icons';
import { currentUser } from '../utils/api';

const key = () => `showTips:${currentUser()?.username || ''}`;

const TipsSwitch = () => {
  const [on, setOn] = useState(localStorage.getItem(key()) !== '0');

  useEffect(() => {
    document.body.classList.toggle('hide-tips', !on);
  }, [on]);

  const change = (v) => {
    setOn(v);
    localStorage.setItem(key(), v ? '1' : '0');
  };

  return (
    <Tooltip title={on ? 'Hide the tip boxes on every screen' : 'Show the tip boxes on every screen'}>
      <span style={{ whiteSpace: 'nowrap' }}>
        <BulbOutlined style={{ color: on ? '#faad14' : '#bbb', marginRight: 4 }} />
        <Switch size="small" checked={on} onChange={change} checkedChildren="Tips" unCheckedChildren="Tips" />
      </span>
    </Tooltip>
  );
};

export default TipsSwitch;
